export default "__VITE_ASSET__sGh4yLJT__"